import '.b4{position:relative;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.a8{justify-content:center;}.ssr-plugin'
import '.a7{align-items:center;}.ssr-plugin'
import '.c6{position:absolute;}.ssr-plugin'
import '.bl{top:0px;}.ssr-plugin'
import '.hg{right:-4px;}.ssr-plugin'
import '.eb{width:1.5rem;}.ssr-plugin'
import '.ec{height:1.5rem;}.ssr-plugin'
import '.ax{border-radius:1.25rem;}.ssr-plugin'
import '.hh{background-color:var(--brand-primary);}.ssr-plugin'
import '.ai{cursor:pointer;}.ssr-plugin'
import { Image } from '@app/components/core/image/Image'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { styled } from 'inlines'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashUndo } from '@fortawesome/pro-solid-svg-icons'

export const PreviewImage = ({
  src,
  onDelete,
  onCancelDelete,
}: {
  src: string
  onDelete?: () => void
  onCancelDelete?: () => void
}) => {
  const showDeleteButton = onDelete && !onCancelDelete
  const showCanceleDelete = onDelete && !!onCancelDelete
  return (
    <div className="b4 d a8 a7"
    >
      <Image
        onClick={onCancelDelete}
        src={src}
        resizeWidth={90}
        style={{
          width: '5.625rem',
          height: '5.625rem',
          borderRadius: '1.25rem',
          objectFit: 'cover',
          objectPosition: 'center',
          aspectRatio: '1/1',
          flexShrink: 0,
          filter: showCanceleDelete ? 'brightness(50%)' : 'none',
        }}
      />
      {showDeleteButton && <RemoveImageIcon onClick={onDelete} />}
      {showCanceleDelete && (
        <FontAwesomeIcon
          onClick={onCancelDelete}
          icon={faTrashUndo}
          color="var(--palette-white)"
          fontSize={'3rem'}
          style={{ position: 'absolute' }}
        />
      )}
    </div>
  )
}

const RemoveImageIcon = ({ onClick }: { onClick: () => void }) => {
  return (
    <div className="d a8 a7 c6 bl hg eb ec ax hh ai"
      onClick={onClick}
    >
      <FontAwesomeIcon icon={faXmark} color="var(--palette-white)" />
    </div>
  )
}
